import { DateTime } from 'luxon'

/**
 * The Marketplace REST API's datetime strings carry no UTC offset (e.g.
 * `"2026-07-24 06:02:00"`), but are always UTC regardless (HATCH-36 review,
 * reaffirmed on HATCH-69: every migrated app must show a timestamp field in
 * the viewer's own local timezone, never the raw UTC string). A bare
 * `DateField` `transform` (`new Date(value)`) would parse a no-offset string
 * as *local* time instead, showing the wrong instant — this forces the UTC
 * interpretation before handing off to `DateField`'s own (already-local)
 * `toLocaleString`/`toLocaleDateString` display.
 *
 * See `AGENTS.md`'s "Timestamp fields" section — every migrated app's
 * `created_at`/`updated_at`/etc. read-mode display must use this, via a
 * `ResourceTable`/`EditableTable` `renderField` override, not the raw ISO
 * string `renderDefaultFieldValue` falls back to.
 */
export function fromApiUtc(value: unknown): Date {
  return DateTime.fromISO(String(value), { zone: 'utc' }).toJSDate()
}
